// extracted by mini-css-extract-plugin
export default {"changePasswordForm":"changepassword_changePasswordForm__dKKKd","formInputs":"changepassword_formInputs__oPXvh","changePasswordButton":"changepassword_changePasswordButton__gQs+Q"};